const pagos = {
    
    ReporteCaja: 'SIVAC/Reportes/ReportesFecha',
    ReporteDevoluciones: 'SIVAC/Reportes/ReportesFechaDevoluciones'
}

const firmas = {

    BuscarFirmasNoVigentesSemanaActual: 'SIVAC/Reportes/Firmas/BuscarFirmasNoVigentesSemanaActual',
    BuscarFirmasNoVigentesSemanaAnterior: 'SIVAC/Reportes/Firmas/BuscarFirmasNoVigentesSemanaAnterior',
    BuscarFirmasNoVigentesPorPeriodoDeFecha: 'SIVAC/Reportes/Firmas/BuscarFirmasNoVigentesPorPeriodoDeFecha',
    BuscarFirmasNoVigentesPorHistorial: 'SIVAC/Reportes/Firmas/BuscarFirmasNoVigentesPorHistorial',
    BuscarFirmasVigentesEnTiempo: 'SIVAC/Reportes/Firmas/BuscarFirmasVigentesEnTiempo',
    BuscarFirmasVigentesFueraDeTiempo: 'SIVAC/Reportes/Firmas/BuscarFirmasVigentesFueraDeTiempo',
    BuscarFirmasVigentesConPermiso: 'SIVAC/Reportes/Firmas/BuscarFirmasVigentesConPermiso',
    BuscarMensajesRecibidosSemanaActual: 'SIVAC/Reportes/Firmas/BuscarMensajesRecibidosSemanaActual',
    BuscarMensajesRecibidosSemanaAnterior: 'SIVAC/Reportes/Firmas/BuscarMensajesRecibidosSemanaAnterior',
    BuscarMensajesRecibidosPorPeriodoDeFecha: 'SIVAC/Reportes/Firmas/BuscarMensajesRecibidosPorPeriodoDeFecha',
    BuscarMensajesRecibidosPorHistorial: 'SIVAC/Reportes/Firmas/BuscarMensajesRecibidosPorHistorial',
    BuscarMensajesNoRecibidos: 'SIVAC/Reportes/Firmas/BuscarMensajesNoRecibidos',
    BuscarFirmantes: 'SIVAC/Reportes/Firmas/BuscarFirmantes',
    BuscarFirmantesDadosDeBaja: 'SIVAC/Reportes/Firmas/BuscarFirmantesDadosDeBaja',
    BuscarMovimientosBitacoraSemanaActual: 'SIVAC/Reportes/Firmas/BuscarMovimientosBitacoraSemanaActual',
    BuscarMovimientosBitacoraSemanaAnterior: 'SIVAC/Reportes/Firmas/BuscarMovimientosBitacoraSemanaAnterior',
    BuscarMovimientosBitacoraPorPeriodoDeFecha: 'SIVAC/Reportes/Firmas/BuscarMovimientosBitacoraPorPeriodoDeFecha',
    BuscarMovimientosBitacoraPorHistorial: 'SIVAC/Reportes/Firmas/BuscarMovimientosBitacoraPorHistorial'
    
}

const deposito = {

    BuscarEndososPorPeriodoDeFecha: 'SIVAC/Reportes/Depositos/BuscarEndososPorPeriodoDeFecha',
    BuscarEndososSemanaActual: 'SIVAC/Reportes/Depositos/BuscarEndososSemanaActual',
    BuscarEndososSemanaAnterior: 'SIVAC/Reportes/Depositos/BuscarEndososSemanaAnterior',
    BuscarEndososPorHistorial: 'SIVAC/Reportes/Depositos/BuscarEndososPorHistorial',
    BuscarEndososPagadosPorPeriodoDeFecha: 'SIVAC/Reportes/Depositos/BuscarEndososPagadosPorPeriodoDeFecha',
    BuscarEndososPagadosPorHistorial: 'SIVAC/Reportes/Depositos/BuscarEndososPagadosPorHistorial',
    BuscarChequesPorPeriodoDeFecha: 'SIVAC/Reportes/Depositos/BuscarChequesPorPeriodoDeFecha',
    BuscarChequesSemanaActual: 'SIVAC/Reportes/Depositos/BuscarChequesSemanaActual',
    BuscarChequesSemanaAnterior: 'SIVAC/Reportes/Depositos/BuscarChequesSemanaAnterior',
    BuscarChequesPorHistorial: 'SIVAC/Reportes/Depositos/BuscarChequesPorHistorial'


}

const reportes = {
    pagos: pagos,
    firmas: firmas,
    deposito: deposito
}

export default reportes;


//////////////////
// WEBPACK FOOTER
// ./static/js/api/SIVAC/Sistema/Reportes/reportes.js
// module id = null
// module chunks = 